import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/gears.svg
 */
const IconGears: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.317 4.005a1.23 1.23 0 00-1.364 1.08l-.11.94c-.33.057-.65.149-.954.272L6.3 5.555a1.23 1.23 0 00-1.729-.201l-.15.12a1.23 1.23 0 00-.202 1.728l.588.742c-.19.269-.353.559-.484.867l-.94-.11A1.23 1.23 0 002.02 9.783l-.022.192a1.23 1.23 0 001.08 1.364l.94.11c.057.33.149.65.272.954l-.742.588a1.23 1.23 0 00-.201 1.729l.12.15a1.23 1.23 0 001.728.201l.742-.587c.269.19.559.352.867.483l-.109.94a1.23 1.23 0 001.08 1.365l.192.022a1.23 1.23 0 001.364-1.08l.11-.94c.33-.057.65-.149.954-.272l.588.742a1.23 1.23 0 001.729.201l.15-.12a1.23 1.23 0 00.202-1.728l-.588-.742c.19-.269.353-.56.484-.867l.94.109a1.23 1.23 0 001.364-1.08l.022-.192a1.23 1.23 0 00-1.08-1.364l-.94-.11a4.667 4.667 0 00-.272-.954l.742-.588a1.23 1.23 0 00.201-1.729l-.12-.15a1.23 1.23 0 00-1.728-.202l-.742.588a4.665 4.665 0 00-.867-.484l.109-.94a1.23 1.23 0 00-1.08-1.364l-.192-.022zm-.874 8.354a1.722 1.722 0 10.398-3.42 1.722 1.722 0 00-.398 3.42z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.308 11.362a.828.828 0 00-.557 1.03l.182.61a3.133 3.133 0 00-.518.421l-.56-.303a.828.828 0 00-1.121.335l-.062.114a.828.828 0 00.335 1.121l.56.303c-.046.216-.07.439-.069.664l-.61.182a.828.828 0 00-.556 1.03l.037.124a.828.828 0 001.03.556l.61-.181c.122.189.264.362.42.518l-.302.56a.828.828 0 00.335 1.121l.114.062a.828.828 0 001.121-.335l.303-.56c.216.046.439.07.664.069l.182.61a.828.828 0 001.03.556l.124-.037a.828.828 0 00.556-1.03l-.181-.61c.188-.122.362-.264.517-.42l.56.302a.828.828 0 001.122-.335l.061-.114a.828.828 0 00-.334-1.122l-.56-.302c.046-.216.07-.439.069-.664l.61-.182a.828.828 0 00.556-1.03l-.037-.124a.828.828 0 00-1.03-.557l-.61.182a3.137 3.137 0 00-.421-.518l.303-.56a.828.828 0 00-.335-1.121l-.114-.062A.828.828 0 0018.61 12l-.302.56a3.138 3.138 0 00-.664-.069l-.182-.61a.828.828 0 00-1.03-.556l-.124.037zm1.677 5.394a1.158 1.158 0 10-.662-2.218 1.158 1.158 0 00.662 2.218z"
      fill="currentColor"
    />
  </svg>
);

export default IconGears;
